module.exports = __webpack_public_path__ + "media/app/components/DownloadApp/GoogleStore.49dc322a.svg";